import { sumOfAmounts, sumOfBudgetAmounts } from "./financeUtils";
import { customSortingOrder } from "./sortingOrder";
import { accountNumbersToSum, accountNumbersProduktionsOmkostning, accountNumbersAdministrationsOmkostninger } from "./constants";

export const processFinancialData = (data, sourceType, totalAmount) => {
    if (!Array.isArray(data)) {
        console.error("Invalid data passed to processFinancialData:", data);
        return [];
      }
      let processedData = [...data];
      const omsætningIaltAmount = data.find(item => item.accountName === "Omsætning ialt")?.amount || 0;
        const renameMapping = {
          "Likvide beholdninger ialt": "Bank",
          "Omsætning ialt": "Omsætning i alt",
          "Tilgodehavender fra salg & tjenesteydelser": "Debitorer",
          "Varekreditorer": "Kreditor",
          "Årets resultat": "Periodens resultat"
        };
    
        processedData = processedData.map((balance) => {
          const newName = renameMapping[balance.accountName];
          if (newName) {
            return {...balance, accountName: newName};
          }
          return balance;
        });
        const sumData = [
          { accountNumbers: accountNumbersToSum, name: "Underleverendører", accountNumber: 119799 },
          { accountNumbers: accountNumbersProduktionsOmkostning, name: "Produktionsomkostninger", accountNumber: 1198001 },
          { accountNumbers: accountNumbersAdministrationsOmkostninger, name: "Administrationsomkostninger", accountNumber: 1198002 },
        ];
        sumData.forEach(({ accountNumbers, name, accountNumber }) => {
          const sumFunc = sourceType === 'budget' ? sumOfBudgetAmounts : sumOfAmounts;
          const amount = sumFunc(data, accountNumbers);
          const newData = {
            accountType: "sum",
            accountName: name,
            accountNumber
          };
      
          if (sourceType === 'budget') {
            newData.periods = [{amount}];
          } else {
            newData.amount = amount;
          }
          processedData.push(newData);
        });
        let accountNumbersToFilter = [2040, 1995, 2995, 2010, 2040, 3190, 5998, 3898, 119799, 1198001, 1198002];
        let likvidAccountNumberToFilter = [7100, 8870, 7228]
        if (sourceType === 'budget') {
          const budgetAccountNumbersToRemove = [7228, 7100, 8870, 1070, 1075];
        const filterAccountNumbers = (numbers) => {
          return numbers.filter(number => !budgetAccountNumbersToRemove.includes(number));
        };
        accountNumbersToFilter = filterAccountNumbers(accountNumbersToFilter);
      }
      if(sourceType === 'likvid'){
        const likvidAccountNumbersToRemove = [2040, 1995, 1075, 2995, 2010, 2040, 3190, 4798, 119799]
      const filterAccountNumbers = (numbers) => {
        return numbers.filter(number => !likvidAccountNumbersToRemove.includes(number))
      }
      accountNumbersToFilter = filterAccountNumbers(likvidAccountNumberToFilter)
      }

      return processedData
      .filter(balance => accountNumbersToFilter.includes(balance.accountNumber))
      .sort((a, b) => {
        const aIndex = customSortingOrder.indexOf(a.accountName);
        const bIndex = customSortingOrder.indexOf(b.accountName);
        return aIndex - bIndex;
      })
      .map((balance) => {
        let percentage;
        
        const noPercentageAccountNames = [
          "Årets resultat", 
          "Debitorer", 
          "Kreditor", 
          "Igangværende arbejde primo", 
          "Igangværende arbejde ultimo",
          "Dækningsbidrag",
          "Bank", 
    
        ];
        
        if (sourceType === 'budget') {
          const budgetAmount = balance.periods && balance.periods.length > 0
            ? balance.periods[0].amount
            : 0;
        
          
          const omsætningIaltBudgetAmount = data.find(item => item.accountName === "Omsætning ialt")?.periods?.[0]?.amount || 0;
        
          if (!noPercentageAccountNames.includes(balance.accountName) && omsætningIaltBudgetAmount) {
            percentage = ((budgetAmount / omsætningIaltBudgetAmount) * 100).toFixed(2);
          } else {
            percentage = null; 
          }
      } else {
        if (!noPercentageAccountNames.includes(balance.accountName) && omsætningIaltAmount) {
        percentage = ((balance.amount / omsætningIaltAmount) * 100).toFixed(2); 
        }
      }

      
        
        return { ...balance, percentage };
      });
    };